<ng-template #template let-row="row">
  <tr
    fd-table-row
    class="atom-table-row {{
      isResourcesTable ? utils.concatTypeAndName(row) : ''
    }}"
    [focusable]="true"
    (click)="onClick(row)"
    [activable]="clickable"
    [ngClass]="{ selected: isSelected, hovering: currentHoverItem === row }"
    [hoverable]="true"
    (mouseenter)="onHoverRow(row)"
    (mouseleave)="onHoverRow(null)"
  >
    @if (!!expandContent) {
      <td fd-table-cell>
        <button
          fd-button
          class="toggle-button"
          [glyph]="this.isExpanded ? 'slim-arrow-down' : 'slim-arrow-right'"
          value="first"
          (click)="toggleRow()"
        ></button>
      </td>
    }

    <ng-container *ngTemplateOutlet="cellsContent"></ng-container>
  </tr>
  @if (!!expandContent && isExpanded) {
    <tr fd-table-row class="atom-table-row">
      <td fd-table-cell colspan="100%" class="expandable-td">
        <div class="expand-content">
          <ng-container
            *ngTemplateOutlet="expandContent; context: { row: row }"
          ></ng-container>
        </div>
      </td>
    </tr>
  }
</ng-template>
